import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const post = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return new Promise((resolve, reject) => {
      post
        .get("/post?" + qstr)
        .then(res => {
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              res.data.data.map(el => {
                el.created_at = fx.formatDateTime(
                  el.created_at,
                  this.$store.getters.timezone
                );
                el.updated_at = el.updated_at
                  ? fx.formatDateTime(
                      el.updated_at,
                      this.$store.getters.timezone
                    )
                  : "";
              });
            } else {
              if (res.data.data.data && res.data.data.data.length > 0) {
                res.data.data.data.map(el => {
                  el.created_at = fx.formatDateTime(
                    el.created_at,
                    this.$store.getters.timezone
                  );
                  el.updated_at = el.updated_at
                    ? fx.formatDateTime(
                        el.updated_at,
                        this.$store.getters.timezone
                      )
                    : "";
                });
              }
            }
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  find(id) {
    return post.get("/post/detail/" + id);
  },
  create(inputs) {
    return post.post("/post", inputs);
  },
  update(id, inputs) {
    return post.put("/post/" + id, inputs);
  },
  delete(id) {
    return post.delete("/post/" + id);
  },
  getByCat(id) {
    return post.get("/post/category/" + id);
  },
  search(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return post.get("/post/search?" + qstr);
  },
  getCatByType(qstr) {
    qstr = fx.urlQueryString(qstr, false);
    return post.get("/post/categories-by-type?" + qstr);
  },
  searchWinemag(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return post.get("/post/search?" + qstr);
  }
};
